import {
  BaseApiService,
  type JsonApiResource,
  type JsonApiResponse,
} from '@/shared/api/services/base.service';
import type { PaymentMethodData } from '@/types/stripe';

export type PaymentMethodResource = JsonApiResource<PaymentMethodData>;

// Legacy Stripe-era saved cards. The dedicated "Payment methods" management
// page was removed when web payments moved to Paddle (Merchant of Record, no
// card storage on our side). Only `list()` survives, used by the legacy
// token/subscription checkout pages to optionally prefill a saved card; under
// Paddle the endpoint returns nothing and callers fall back to an empty list.
class PaymentMethodsService extends BaseApiService {
  async list(): Promise<PaymentMethodData[]> {
    const response = await this.httpGet<JsonApiResponse<PaymentMethodResource[]>>(
      '/v1/payment-methods'
    );
    return this.normalizeMany(response);
  }
}

export const paymentMethodsService = new PaymentMethodsService();
